import styled from 'styled-components';
import { COLOR_RED, COLOR_WHITE } from '../constants';

const Div = styled.div`
  ${p => p.center && 'text-align: center'};
  border-radius: 8px;
  padding: 20px 80px;
  box-shadow: 0px 2px 16px 0px rgba(43, 85, 162, 0.11);
  background-color: ${COLOR_RED};
  color: ${COLOR_WHITE};
  font-weight: bold;
`;

export default Div;
